// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { OperatorApi } from '@digitalasset/utility-operator-api-ts-client';
import React, { useContext } from 'react';

export const UtilityOperatorApiContext = React.createContext<OperatorApi | undefined>(undefined);

export const useUtilityOperatorApiClient: () => OperatorApi = () => {
  const client = useContext<OperatorApi | undefined>(UtilityOperatorApiContext);
  if (!client) {
    throw new Error('UtilityOperator client not initialized');
  }
  return client;
};
